export enum InteractionType {
    Click = 'click',
    MouseEnter = 'mouseenter',
    MouseLeave = 'mouseleave'
}
